<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <truncate-text *ngIf="isLoaded" fxFlex="100" [allowHtml]="true" [mainText]="department()"
                           class="forge-typography--subheading1">
            </truncate-text>
        </div>

        <div slot="end" *ngIf="isLoaded && chartHasData" style="text-align: right; margin-right: 2em;">
            <span class="forge-typography--heading2">Ordered total:</span> {{total}}
        </div>

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
                           telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">Not enough data to display graph</div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </div>
</forge-card>
